<template>
  <div class="i-detail" @click.stop="handleClick">
    <div class="top">
      <div style="font-weight: bold">
        {{ name }}：{{ productInfo.product_model}},{{ handleAllInfo(productInfo) }}
      </div>
      <el-popover placement="bottom-end" width="400" trigger="click">
        <div class="shareshow">
          <div class="share-title">
            <div class="share-mail">
              <span><i class="el-icon-message"></i> {{ $t('main.shareToEmail') }}</span>
            </div>
            <el-button
                @click="subShare"
                size="small"
                class="share-button">
              {{ $t('main.send') }}
            </el-button>
          </div>
          <div class="share-content">
            <div class="input-box">
              <div class="input-title">
                <span class="required">*</span>
                {{ $t('main.yourEmail') }}：
              </div>
              <el-input
                  class="input"
                  v-model="send_email"
                  :placeholder="$t('main.yourEmail')"
                  size="medium">
              </el-input>
            </div>
            <div class="input-box">
              <div class="input-title">
                <span class="required">*</span>
                {{ $t('main.friedEmail') }}：
              </div>
              <el-input
                  class="input"
                  v-model="send_to_email"
                  :placeholder="$t('main.friedEmail')"
                  size="medium">
              </el-input>
            </div>
            <div class="input-box">
              <div class="input-title">
                <span class="required">*</span>
                {{ $t('main.comments') }}：
              </div>
              <el-input
                  class="input"
                  v-model="share_content"
                  :placeholder="$t('main.shareContent')"
                  type="textarea"
                  :rows="3">
              </el-input>
            </div>
          </div>
        </div>
        <div class="cus" slot="reference">
          <div class="d-i">
            <i class="el-icon-share"></i>
          </div>
        </div>
      </el-popover>
    </div>
    <div class="d-table" style="display: flex;flex-wrap: wrap">
      <div
        class="fac d-td"
        v-for="(item, index) in detailColumns"
        :key="index"
        style="width: 50%"
        :style="{
          backgroundColor:
            index % 4 !== 0 && (index - 1) % 4 !== 0 ? '#ebebeb' : '#fafafa'
        }"
      >
        <div style="width: 100%;display: flex;align-items: center">
          <div class="d-td-ll" style="width: 40%">{{ item.title }}</div>
          <div style="width: 60%">{{ info[item.varname] }}</div>
        </div>
      </div>
      <div
        class="fac d-td"
        style="width: 50%;"
        :style="{
          backgroundColor:
            detailColumns.length % 4 !== 0 && (detailColumns.length - 1) % 4 !== 0
              ? '#ebebeb'
              : '#fafafa',
        }"
        v-if="detailColumns.length % 2 !== 0"
      ></div>
    </div>
    <div class="facac">
      <a
          v-for="item in productInfo.download_fields"
          :href="item.file_path"
          target="_blank"
          class="download_file"
      >
        <div class="facab btn-box">
          <div class="file">
            {{ item.ori_name }}
          </div>
          {{ $t('main.download') }}
        </div>
      </a>
      <a
          :href="'https://www.u-optic.com/download/specification?id=' + productInfo.id"
          target="_blank"
          class="download_file"
      >
        <div class="facab btn-box">
          <div class="file">
            {{ $t('main.Specification') }}
          </div>
          {{ $t('main.download') }}
        </div>
      </a>
    </div>

    <div class="b-tool fac" v-if="list.length !== 0">
      <div class="b-t-l fac">
        <div class="b-t-l-c">
          <img :src="productInfo.thumb" class="pImg" />
          <div :title="productInfo.product_model" class="nowap">
            {{ productInfo.product_model }}
          </div>
          <div class="color-635796">{{ $t('main.monetaryUnit') }}{{ productInfo.price }}</div>
          <div class="b-t-l-t nowap" :title="name">{{ name }}</div>
          <div class="b-t-l-t nowap" :title="handleAllInfo(productInfo)">{{ handleAllInfo(productInfo) }}</div>
        </div>
        <div class="plus">
          <i class="el-icon-plus"></i>
        </div>
        <el-checkbox-group v-model="checkList">
          <div class="b-t-l-nc" v-for="(item, index) in list" :key="index">
            <img :src="item.thumb" class="pImg" @click.stop="handleDetail(item)" />
            <div :title="item.product_model" class="nowap" @click.stop="handleDetail(item)">
              {{ item.product_model }}
            </div>
            <div class="color-635796">{{ $t('main.monetaryUnit') }}{{ item.price }}</div>
            <div class="b-t-l-t nowap" :title="item.type_name" @click.stop="handleDetail(item)">{{ item.type_name }}</div>
            <div class="b-t-l-t nowap" :title="handleAllInfo(item)">{{ handleAllInfo(item) }}</div>
            <el-checkbox v-if="item.stock == 0" @change="getTotalPrice" :label="item.id" class="cImg" disabled></el-checkbox>
            <el-checkbox v-else @change="getTotalPrice" :label="item.id" class="cImg"></el-checkbox>
          </div>
        </el-checkbox-group>
      </div>
      <div class="b-t-r" v-if="list.length">
        <div class="fac">
          <div>
            <div @click="changePage('next')">
              <img src="/static/product/icn_d_left.png" class="rTImg" />
            </div>
            <div style="margin-top: 0.25rem;" @click="changePage('pre')">
              <img src="/static/product/icn_d_right.png" class="rTImg" />
            </div>
          </div>
          <div class="cbox">
            <div v-html="$t('main.chooseShopNum', { num: totalNumber })"></div>
            <div style="margin: 0.5rem 0;">
              {{ $t('main.totalPrice') }}：<span v-html="$t('main.amountConvert', { amount: totalPrice })"></span>
            </div>
            <el-button class="mainBtn addShopCarForGoogle" @click="addToShoppingCar()"
              > {{ $t('main.addShopCar') }}</el-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { addShopcar } from '@/api/shopcar';
import {addShare, getProductInfo} from "@/api";
import { cloneDeep } from 'lodash'
import Cookies from "js-cookie";

export default {
  props: ["productInfo", "columns", "infoColumns", "name"],
  data() {
    return {
      list: [],
      filterArr: ["price", "stock"],
      listCopy: [],
      checkList: [],
      page: 1,
      send_email:'',
      totalNumber: 0,
      totalPrice: 0,
      send_to_email:'',
      share_content:'',
      detailTitle: [],
      detailColumns: [],
      templates: {
        index: "/",
        single_intro: "/about",
        single_map: "/service/map",
        single_term: "/service/term",
        single_contact: "/contact",
        category_product: "/product",
        category_product_more: "/product/more",
        detail_product:"/product/detail",
        category_join: "/contact",
        category_steps: "/service/steps",
        category_news: "/news",
        category_productDirectory: "/service",
        detail_article: "/news/detail",
      }
    };
  },
  watch: {
    infoColumns: {
      handler: function(newV) {
        let detailTitle = [];
        newV.filter(item => {
          if (!this.filterArr.includes(item.varname) && item.isShow) {
            detailTitle.push(item.varname);
          }
        });
        this.detailTitle = detailTitle;
        this.detailColumns = newV.filter(item => {
          return !this.filterArr.includes(item.varname);
        });
      },
      immediate: true
    },
    "productInfo.num": function() {
      this.getTotalPrice();
    }
  },
  computed: {
    info() {
      let res = {};
      let columns = this.detailColumns.map((item) => {
        return item.varname
      });
      columns.forEach((item) => {
        res[item] = this.productInfo[item];
      });
      return res;
    }
  },
  mounted() {
    this.init();
    this.getTotalPrice();
    this.send_email = Cookies.get("userinfo") && (JSON.parse(Cookies.get("userinfo")) && JSON.parse(Cookies.get("userinfo")).email) || "";
  },
  methods: {
    init() {
      // 处理推荐产品分页
      this.listCopy = cloneDeep(this.productInfo.product_posid || [])
      this.list = this.listCopy.slice(0, 5)
    },
    getTotalPrice() {
      // 计算总价格
      let totalNumber = 0;
      let totalPrice = 0;
      if (this.productInfo.stock != 0) {
        totalNumber = this.productInfo.num;
        totalPrice =  Math.round( this.productInfo.price * this.productInfo.num * 100)/100;
      }
      if (this.checkList.length) {
        let res = 0
        this.list.forEach((item) => {
          if (this.checkList.indexOf(item.id) > -1) {
            res += parseFloat(item.price)
          }
        })
        // 保留两位小数
        totalNumber = totalNumber + this.checkList.length;
        totalPrice = Math.round( (totalPrice + res) * 100)/100;
      }

      this.totalNumber = totalNumber;
      this.totalPrice = totalPrice;
    },
    handleAllInfo(data) {
      if (Object.prototype.toString.call(data) !== '[object Object]') return
      let res = ''
      data.product_data.forEach((item) => {
        if (item.isShow) {
          res = `${res}${item.value ? item.value : ''}${item.value ? ',' : ''}`
        }
      })

      res.slice(res.length - 2, res.length - 1);
      return res.slice(0, -1);
    },
    handleClick() {},
    //加入购物车

    addToShoppingCar() {
      let params = {
        req: {
          product_ids: this.checkList.map((item) => {
            return {
              product_id: item,
              number: 1,
            }
          }),
        },
      };

      if (this.productInfo.stock != 0) {
        // 将产品自己追加
        params.req.product_ids.push({
          product_id: this.productInfo.id,
          number: this.productInfo.num,
        });
      }

      if (params.req.product_ids.length === 0) {
        this.$message({
          message: this.$t('main.pleaseSelectProduct'),
          type: 'error',
        })
        return false
      }
      addShopcar(params).then((res) => {
        if (res.rsp.code === 0) {
          this.checkList = []
          this.$store.dispatch('setCarNum', true)
          this.$message({
            message: this.$t('main.operationCompletedSuccessfully'),
            type: 'success',
          })
        } else {
          this.$message({
            message: res.rsp.msg,
            type: 'error',
          })
        }
      })
    },
    changePage(text) {
      if (text === 'next') {
        this.page = this.page === 1 ? this.page : this.page - 1
      } else {
        if (this.listCopy.length <= this.page * 5) return
        this.page += 1
      }
      this.listChange()
    },
    listChange() {
      this.list = this.listCopy.slice((this.page - 1) * 5, this.page * 5)
    },
      // 分享商品
    subShare() {
      let params = {
        req: {
          send_email: this.send_email,
          send_to_email: this.send_to_email,
          share_url: location.href,
          share_content: this.share_content,
          send_type: 1,
        },
      };
      addShare(params).then((res) => {
        if (res.rsp.code === 0) {
          this.$message({
            message: this.$t('main.operationCompletedSuccessfully'),
            type: "success",
          });
        } else {
          this.$message({
            message: res.rsp.msg,
            type: "error",
          });
        }
      });
    },
    handleDetail(item) {
      let params = {
        req: {
          id: item.type_id
        }
      };
      getProductInfo(params).then(res => {
        if(res.rsp.code === 0) {
          const toItem = res.data;
          let route = this.$router.resolve({
            path: this.getRoutesPath('detail_product', toItem['identification'], toItem['id']),
            query: {
              keyword: item.product_model,
              anchor: "filter"
            }
          });
          window.open(route.href, "_blank");
          window.sessionStorage.setItem("recommend", true);

        } else {
          this.$message({
            message: res.rsp.msg,
            type: "error",
          });
        }
      });
    },
    getRoutesPath(template, identification, id) {
      let basePath  = this.templates[template];
      let paramsUrl = '';
      if (identification !== '') {
        paramsUrl = '/'+identification;
      } else if (id !== 'productCenter' && id !== 'index' && id !== '0') {
        paramsUrl = '/'+id;
      } else {
        paramsUrl = '';
      }

      return basePath + paramsUrl;
    },
  },
}
</script>

<style scoped lang="less">
.shareshow {
  background-color: white;
  opacity: 1;
}
.shareshow .share-title{
  display:flex;
  justify-content: space-between;
  vertical-align:center;
  margin-bottom: 3px;
}
.shareshow .share-title .share-mail {
  padding: 5px 10px;
  display:flex;
  justify-content: center;
  vertical-align:center;
  background-color:#f0f0f0;
  border-radius: 5px;
}
.shareshow .share-title .share-mail .el-icon-message {
  color: #635796;
}
.shareshow .share-title .share-button {
  width: 86px;
  height: 32px;
  background: #635796;
  border-radius: 4px;
  color: #ffffff;
  padding: 0;
}
.shareshow .share-content {
  background-color:#f0f0f0;
  padding: 5px;
  border-radius: 3px;
}
.shareshow .share-content .input-box {
  display: flex;
  margin: 5px 0;
}
.shareshow .share-content .input-box .input-title {
  width: 35%;
  line-height: 40px;
  text-align: right;
}
.shareshow .share-content .input-box .input {
  width: 70%;
}
.i-detail {
  background-color: #f0f0f0;
  padding-bottom: 1rem;

  .top {
    padding: 1.25rem 2rem 1.25rem 1.5rem;
    position: relative;
    text-align: center;

    .d-i {
      cursor: pointer;
      position: absolute;
      right: 2rem;
      top: 1.25rem;
      .el-icon-share {
        font-size: 1.5rem;
        color: #635796;
      }
    }
  }

  .d-table {
    margin: 0 2rem 1.25rem 1.25rem;
    border-top: 1px solid #b3b3b3;
    border-left: 1px solid #b3b3b3;

    .d-td {
      border-bottom: 1px solid #b3b3b3;
      border-right: 1px solid #b3b3b3;
      min-height: 1.8rem;

      .d-td-l {
        width: 50%;
        height: 100%;
        border-right: 1px solid #b3b3b3;
      }

      .d-td-r {
        width: 50%;
        height: 100%;
      }

      .d-td-ll {
        margin-left: 20%;
        width: 6.25rem;
        font-weight: bold;
        color: #4d4d4d;
      }
    }
  }

  .download_file {
    margin: 0.2rem;
    .btn-box {
      height: 2.25rem;
      border: 1px solid #635796;
      border-radius: 4px;
      padding: 0 0.625rem;
      color: #635796;

      .file {
        padding-right: 1rem;
      }
    }
  }

  .btn-box + .btn-box {
    margin-left: 0.625rem;
  }

  .b-tool {
    padding: 1.25rem 2rem 1.25rem 1.5rem;

    .b-t-l {
      width: calc(100% - 240px);
      overflow-x: auto;

      .plus {
        margin: 0 1.5rem;
      }

      .b-t-l-c {
        width: 148px;
        position: relative;
      }

      .cImg {
        position: absolute;
        right: 0;
        top: 0;
        width: 1.25rem;
        height: 1.25rem;
      }

      .pImg {
        width: 148px;
        border-radius: 0.3rem;
      }

      .b-t-l-nc {
        width: 148px;
        position: relative;
        font-size: 12px;
        cursor: pointer;
      }

      .b-t-l-nc + .b-t-l-nc {
        margin-left: 2.5rem;
      }

      .mb20 {
        margin-bottom: 1.25rem;
      }
    }

    .b-t-r {
      width: 240px;

      .rTImg {
        width: 38px;
        height: 60px;

        &:hover {
          cursor: pointer;
        }
      }

      .cbox {
        margin-left: 8px;
        width: 194px;
        height: 128px;
        background-color: #fff;
        border-radius: 10px;
        padding: 16px;

        .mainBtn {
          width: 86px;
          height: 32px;
          background: #635796;
          border-radius: 4px;
          color: #fff;
          padding: 0.5rem;
        }
      }
    }
  }
}

::v-deep .el-checkbox__label {
  display: none;
}

::v-deep .el-checkbox-group {
  display: flex;
}

.required {
  color: #F56C6C;
}

.two-row {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
</style>
